export const isIOS = () => {
  let hasTouchScreen = false;

  if (typeof navigator !== 'undefined') {
    if ('maxTouchPoints' in navigator) {
      // maxTouchPoints returns the maximum number of simultaneous touch contact points
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ('msMaxTouchPoints' in navigator) {
      hasTouchScreen = (navigator as Navigator).maxTouchPoints > 0;
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = (navigator as Navigator).userAgent || '';
      hasTouchScreen = /\b(iPhone |iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
};
